import React from 'react';
import './services.css';
import { FiShoppingCart, FiCode, FiArrowRight } from 'react-icons/fi';

const Services = () => (
  <div className="gpt3__services section__padding" id="services">
    <div className="gpt3__services-heading">
      <h1 className="gradient__text">Premium ECU Solutions & Custom Tuning Services</h1>
      <p>Whether you're looking for Nissan Immo Off, Kia-Hyundai DTC Removal, or custom-built automotive software, Prinze Tuner is your trusted partner.</p>
    </div>

    <div className="gpt3__services-container">
      <div className="gpt3__services-container_card">
        <div className="gpt3__services-container_card-icon">
          <FiShoppingCart />
        </div>
        <div className="gpt3__services-container_card-content">
          <h3>Professional ECU Tools</h3>
          <p>Get access to industry-leading ECU file processing tools for Nissan, Kia, and Hyundai. High-precision tuning and IMMO-OFF solutions without limits.</p>
          <a href="/#products">
            <button type="button">Browse Products <FiArrowRight /></button>
          </a>
        </div>
      </div>

      <div className="gpt3__services-container_card">
        <div className="gpt3__services-container_card-icon">
          <FiCode />
        </div>
        <div className="gpt3__services-container_card-content">
          <h3>Custom Build Service</h3>
          <p>Need something unique? We build bespoke software solutions tailored to your specific automotive requirements. From custom logic to specialized diagnostic tools, we bring your vision to life.</p>
          <a href="https://wa.me/966590707424" target="_blank" rel="noreferrer">
            <button type="button">Request Custom Build <FiArrowRight /></button>
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default Services;
